import { Component, OnInit, Input } from '@angular/core';
import { CustomOktaAuthService } from '../../auth/oktaauth.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit {

  @Input() loadingText: 'Loading. Please wait...';
  @Input() color = 'accent';
  @Input() mode = 'indeterminate' as const;
  @Input() value = 50;

  constructor(private oktaService: CustomOktaAuthService) { }

  ngOnInit() {
    this.oktaService.refreshToken('loading component init');
  }

}
